module.exports = __webpack_public_path__ + "static/img/benchmarking.99054d8.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/benchmarking.png
// module id = Lk0u
// module chunks = 1